module.exports = __webpack_public_path__ + "img/icon-logo.d3f2eed8.svg";